module.exports = __webpack_public_path__ + "static/media/bi.3e29b35c.svg";